[
    {
        "type": "Input",
        "data": {
            "name": "username",
            "label": "نام کاربری",
            "props": {
                "type": "hidden"
            }
        }
    },
    {
        "type": "Password",
        "data": {
            "name": "password",
            "label": "رمز عبور",
            "props": {
                "placeholder": "حداقل 8 حرف",
                "type": "password",
                "autocomplete": "current-password",
                "autofocus": true,
                "size": "xl"
            }
        }
    }
]